import React from 'react';
import styled from 'styled-components';

const CategoryContainer = styled.div`
  font-family: sans-serif;
`;

const Title = styled.h2`
  font-size: 24px;
  margin-bottom: 10px;
  color: #35426d;
`;

const Link = styled.a`
  text-decoration: none;
  color: #35426d;
`;

const FlexContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-top: 20px;
  justify-content: space-between;
`;

const CategoryCard = styled.div`
  background-color: #ffffff;
  cursor: pointer;
  border-radius: 8px;
  padding: 20px;
  transition: all 0.3s ease-in-out;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  flex: 1 1 22%;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;

  &:hover {
    color: white;
    transform: scale(1.05);
    background: linear-gradient(135deg, #ea5d0f, #ffffff);
    box-shadow: rgba(234, 93, 15, 0.4) 0px 8px 24px;
  }

  @media (max-width: 1200px) {
    flex: 1 1 30%; /* 3 items per row */
  }

  @media (max-width: 900px) {
    flex: 1 1 45%; /* 2 items per row */
  }

  @media (max-width: 600px) {
    flex: 1 1 100%; /* 1 item per row */
  }
`;

const CategoryName = styled.h3`
  font-size: 18px;
  margin-bottom: 10px;
`;

const Rating = styled.p`
  font-size: 14px;
  margin-bottom: 5px;
`;

const Experts = styled.p`
  font-size: 14px;
`;

const SkillSection = () => {
  const categories = [
    { name: 'Grants & Scholarships', rating: '4.85 / 5', Experts: ' ' },
    { name: 'Higher Education Guidance', rating: '4.8 / 5', Experts: '' },
    { name: 'Psychometric Counseling', rating: '4.91 / 5', Experts: '' },
    { name: 'Personality Analysis', rating: '4.77 / 5', Experts: '' },
    {
      name: 'Global Internships',
      rating: '4.92 / 5',
      Experts: '',
    },
    {
      name: 'Wellbeing',
      rating: '4.77 / 5',
      Experts: '',
    },
    {
      name: 'Mindfulness',
      rating: '4.79 / 5',
      Experts: '',
    },
    {
      name: 'Diet & Nutrition',
      rating: '4.85 / 5',
      Experts: '',
    },
  ];

  return (
    <Container>
      <ContainerBox>
        <CategoryContainer>
          <Title className="manrope-semibold">Browse talent by category</Title>
          <p className="manrope-regular">
            Looking for work? <Link href="#">Browse experts</Link>
          </p>
          <FlexContainer className="manrope-regular">
            {categories.map((category, index) => (
              <CategoryCard className="clickable" key={index}>
                <CategoryName className="manrope-semibold">
                  {category.name}
                </CategoryName>
                <Rating>★ {category.rating}</Rating>
                <Experts>{category.Experts}</Experts>
              </CategoryCard>
            ))}
          </FlexContainer>
        </CategoryContainer>
      </ContainerBox>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
`;

const ContainerBox = styled.div`
  width: 100%;
  max-width: 1155px;
  padding: 2.25px;
  display: flex;
  flex-wrap: wrap;
`;

export default SkillSection;
